import { routeList } from '@routes/routeList';

export const CATALOG_SECTIONS = {
  equipment: {
    categoryCodeLevel1: 13,
    landingPath: routeList.equipmentPage,
    plpBasePath: routeList.equipmentProductsListPage,
    title: 'تجهیزات پزشکی',
    breadcrumbKey: 'equipment',
  },
  hygiene: {
    categoryCodeLevel1: 11,
    landingPath: routeList.hygienePage,
    plpBasePath: routeList.hygieneProductListPage,
    title: 'بهداشت فردی',
    breadcrumbKey: 'hygiene',
  },
  supplement: {
    categoryCodeLevel1: 10,
    landingPath: routeList.supplementPage,
    plpBasePath: routeList.supplementProductListPage,
    title: 'مکمل',
    breadcrumbKey: 'supplement',
  },
  'mother-kid': {
    categoryCodeLevel1: 12,
    landingPath: routeList.motherKidPage,
    plpBasePath: routeList.motherKidProductsListPage,
    title: 'مادر و کودک',
    breadcrumbKey: 'motherKid',
  },
} as const;

export type CatalogSectionKey = keyof typeof CATALOG_SECTIONS;

export const getCatalogSectionByLevel1 = (
  categoryCodeLevel1?: string | number | null,
) =>
  (Object.entries(CATALOG_SECTIONS) as Array<
    [CatalogSectionKey, (typeof CATALOG_SECTIONS)[CatalogSectionKey]]
  >).find(
    ([, section]) =>
      String(section.categoryCodeLevel1) === String(categoryCodeLevel1),
  )?.[0];

export const getCatalogPlpContextFromPath = (path?: string | null) => {
  const pathname = path?.split('?')[0] || '';

  for (const section of Object.values(CATALOG_SECTIONS)) {
    const prefix = `${section.plpBasePath}/`;
    if (!pathname.startsWith(prefix)) continue;

    const productListName = decodeURIComponent(
      pathname.slice(prefix.length).split('/')[0] || '',
    );
    if (!productListName) continue;

    return {
      plpBasePath: section.plpBasePath,
      productListName,
    };
  }

  return null;
};
